export default __webpack_public_path__ + "static/media/ilustration-02.377bfaad.svg";